'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
var _faTimes = require('@fortawesome/fontawesome-free-solid/faTimes');
var _faTimes2 = _interopRequireDefault(_faTimes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var BazaarVoiceModal = function (_React$Component) {
  _inherits(BazaarVoiceModal, _React$Component);
  function BazaarVoiceModal() {
    _classCallCheck(this, BazaarVoiceModal);
    var _this = _possibleConstructorReturn(this, (BazaarVoiceModal.__proto__ || Object.getPrototypeOf(BazaarVoiceModal)).call(this));
    _this.state = {
      className: 'modal-left'
    };
    return _this;
  }
  _createClass(BazaarVoiceModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;
      document.addEventListener('bvReviewsModalToggle', function () {
        _this2.setState({
          className: 'modal-enter-active'
        });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;
      document.removeEventListener('bvReviewsModalToggle', function () {
        _this3.setState({
          className: 'modal-leave-active'
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;
      return _react2.default.createElement('div', {
        className: 'modal ' + this.state.className
      }, _react2.default.createElement('div', {
        className: 'modal__dialog',
        tabIndex: '-1',
        role: 'dialog'
      }, _react2.default.createElement('div', {
        className: 'modal__content'
      }, _react2.default.createElement('div', {
        className: 'modal__header'
      }, _react2.default.createElement('button', {
        'aria-label': 'Close',
        className: 'modal__close btn btn--close',
        onClick: function onClick() {
          _this4.setState({
            className: 'modal-leave-active'
          });
          setTimeout(function () {
            _this4.setState({
              className: 'modal-left'
            });
          }, 350);
        },
        type: 'button'
      }, _react2.default.createElement(_reactFontawesome2.default, {
        icon: _faTimes2.default
      }))), _react2.default.createElement('div', {
        className: 'modal__body'
      }, _react2.default.createElement('div', {
        id: 'BVRRContainer'
      })))));
    }
  }]);
  return BazaarVoiceModal;
}(_react2.default.Component);
exports.default = BazaarVoiceModal;